import script from "./message-box.vue?vue&type=script&setup=true&lang=js"
export * from "./message-box.vue?vue&type=script&setup=true&lang=js"

import "./message-box.vue?vue&type=style&index=0&id=6d26a302&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d26a302"]])

export default __exports__